import React, { createContext, useContext, useState } from 'react';

interface PeriodState {
  dueDate: string;
  setDueDate: (date: string) => void;
}

const PeriodContext = createContext<PeriodState | undefined>(undefined);

// Default to end of current quarter
function getDefaultDueDate(): string {
  const today = new Date();
  const quarter = Math.floor(today.getMonth() / 3);
  const endOfQuarter = new Date(today.getFullYear(), quarter * 3 + 3, 0);
  return endOfQuarter.toISOString().slice(0, 10);
}

export const PeriodProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [dueDate, setDueDate] = useState(getDefaultDueDate());

  return (
    <PeriodContext.Provider value={{ dueDate, setDueDate }}>
      {children}
    </PeriodContext.Provider>
  );
};

export function usePeriod() {
  const ctx = useContext(PeriodContext);
  if (!ctx) {
    throw new Error('usePeriod must be used within PeriodProvider');
  }
  return ctx;
}
